// @ts-ignore
import("./bootstrap")
